module.exports = __webpack_public_path__ + "assets/img/teacher (34).8884b658.png";